/**
 * Lazy Load Module
 * Handles lazy loading of images using Intersection Observer API
 */

(function() {
  const LazyLoad = {
    init: function() {
      if (!('IntersectionObserver' in window)) {
        this.fallback();
        return;
      }

      const images = document.querySelectorAll('[data-lazy-src], img[loading="lazy"]');
      
      if (images.length === 0) return;

      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            
            if (img.dataset.lazySrc) {
              img.src = img.dataset.lazySrc;
              img.removeAttribute('data-lazy-src');
            }
            
            img.classList.add('loaded');
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.01
      });

      images.forEach(img => {
        imageObserver.observe(img);
      });
    },

    fallback: function() {
      // For browsers without IntersectionObserver support
      const images = document.querySelectorAll('[data-lazy-src]');
      images.forEach(img => {
        if (img.dataset.lazySrc) {
          img.src = img.dataset.lazySrc;
          img.removeAttribute('data-lazy-src');
        }
      });
    }
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => LazyLoad.init());
  } else {
    LazyLoad.init();
  }

  // Re-initialize when AJAX content is loaded
  document.addEventListener('shopify:section:load', () => LazyLoad.init());

  // Export for external use
  window.LazyLoad = LazyLoad;
})();
